export default __webpack_public_path__ + "static/media/bgHome.da5af629.webp";